import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

class TruckerReg extends Component {
    state = { 
        regStatus:false
     }
    render() { 
        return ( 
            <div className="full-div">
                {this.changeRoute()}
                <div className="hero-min">
                    <div className="spacer"></div>
                    <div className="hero-min-topic">
                        <h2>Register Trucker</h2>
                        <p>
                            . <br/><br/><br/>
                        </p>
                    </div>
                </div>
                <div className="reg-sect" data-aos="fade-up">
                    <div className="reg-form">
                        <div className="reg-logo">
                            <img src={require("./../images/reg-logo.png")} width="100%" alt=""/>
                        </div>
                        <form id="reg_form">
                            <label>First Name</label><br/>
                            <input type="text" placeholder="Enter first name" id="f_name" required/><br/>
                            <label>Last Name</label><br/>
                            <input type="text" placeholder="Enter last name" id="l_name" required/><br/>
                            <label>Email Address</label><br/>
                            <input type="email" placeholder="Enter your email" id="email" required/><br/>
                            <label>Phone Number</label><br/>
                            <input type="number" placeholder="Enter phone number" id="phone" required/><br/>
                            <label>Referal Code</label><br/>
                            <input type="text" placeholder="Enter referal code" id="ref_code" /><br/>
                            {/* 
                            <label>password</label><br/>
                            <input type="password" placeholder="Enter passward" id="password" required/><br/>
                            <label>Confirm password</label><br/>
                            <input type="password" placeholder="confirm passward" id="confirm_password" required/><br/>
                            */}
                            <div className="submiter">
                            <p><span className="warning"></span></p>
                            <input type="submit" value="Register"/>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
         );
    }
    
    componentDidMount(){
        window.scrollTo(0, 0);
        const registerForm = document.getElementById('reg_form');
        registerForm.addEventListener('submit', (e)=>{
            this.submitFunction(e)
        })
    }
    submitFunction = (e)=>{
        e.preventDefault();
        const submitButton = document.querySelector('.submiter input')
        submitButton.value = 'Processing. . .'
        let fName = document.getElementById('f_name');
        let lName = document.getElementById('l_name');
        let email = document.getElementById('email');
        let phone = document.getElementById('phone');
        let referalCode = document.getElementById('ref_code');
        /*let password = document.getElementById('password');
        let confirmPassword = document.getElementById('confirm_password');
        if(password.value !== confirmPassword.value){
            submitButton.value = 'Register';
            this.warnUser('passwords do not match')
            return false;
        }*/
        let data = {
            first_name:fName.value,
            last_name:lName.value,
            email:email.value,
            phone:phone.value,
            ref_by:referalCode.value,
            //password:password.value,
            role:1
        } 
        //console.log(data)
        fetch('https://portal.towva.co/api/register',{
            method:'POST',
            body:JSON.stringify(data),
            headers:{
                'Content-type':'Application/json',
                'Access-Control-Allow-Origin':'*'
            }
        })
        .then(res=> res.json())
        .then(res => {
            submitButton.value = 'Register';
            //console.log(res)
            if (res.errors){
                //warningSpace.innerHTML = res.errors.tostring()
                //console.log(res.errors)
                if(res.errors.email){
                    this.warnUser(res.errors.email);
                    email.focus()
                }else if(res.errors.first_name){
                    this.warnUser(res.errors.first_name);
                    fName.focus()
                }else if(res.errors.last_name){
                    this.warnUser(res.errors.last_name);
                    lName.focus()
                }else if(res.errors.phone){
                    this.warnUser(res.errors.phone);
                    phone.focus()
                }else{
                    this.warnUser('Invalid details entered.')
                }
            }else if(res.user){
                sessionStorage.setItem('name',res.user.first_name)
                sessionStorage.setItem('id',res.user.id)
                sessionStorage.setItem('token',res.token)
                //let { regStatus } = this.state;
                this.setState({regStatus:true});
            }else{
                this.warnUser('Poor network, please try again')
            }
        })
        .catch(err=>{
            submitButton.value = 'Register';
            this.warnUser('Invalid details')
            //fName.value = '';
            //lName.value = '';;
        })
    }
    changeRoute(){
        if(this.state.regStatus === true){
            return <Redirect to='/complete-registration'/>
        }
    }
    //Display warning message for four (4) seconds
    warnUser(arg){
        let warningSpace = document.querySelector('.warning');
        warningSpace.innerHTML = arg;
        setTimeout(()=>{
            warningSpace.innerHTML = '';
        }, 4000)
    }
}
 
export default TruckerReg;